/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import { useQuery } from '@tanstack/react-query'
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query'
import { customInstance } from '../../mutator'
import type { HTTPValidationError, MyOrganisationDTO, MyOrganisationsOut } from '../fastAPI.schemas'

/**
 * The organisation the caller is currently working in, and their role.

Follows the active-organisation header, so the answer matches the library
the same request would return. ``is_admin`` is the per-organisation role,
not the Modugen staff flag: it is what decides whether they may change the
shared library. A user without an organisation gets the usual 403
``user_not_assigned_to_organisation``.
 * @summary Get My Organisation
 */
export const getMyOrganisation = (signal?: AbortSignal) => {
  return customInstance<MyOrganisationDTO>({ url: `/my-organisation`, method: 'GET', signal })
}

export const getGetMyOrganisationQueryKey = () => {
  return [`/my-organisation`] as const
}

export const getGetMyOrganisationQueryOptions = <
  TData = Awaited<ReturnType<typeof getMyOrganisation>>,
  TError = HTTPValidationError,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getMyOrganisation>>, TError, TData>
}) => {
  const { query: queryOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetMyOrganisationQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyOrganisation>>> = ({ signal }) =>
    getMyOrganisation(signal)

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMyOrganisation>>,
    TError,
    TData
  > & { queryKey: QueryKey }
}

export type GetMyOrganisationQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMyOrganisation>>
>
export type GetMyOrganisationQueryError = HTTPValidationError

/**
 * @summary Get My Organisation
 */

export function useGetMyOrganisation<
  TData = Awaited<ReturnType<typeof getMyOrganisation>>,
  TError = HTTPValidationError,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getMyOrganisation>>, TError, TData>
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetMyOrganisationQueryOptions(options)

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * Every organisation the caller belongs to -- what the switcher offers.

Oldest first, which is also the order the fallback picks from, so the
first entry is what they get before choosing anything. Deliberately not
behind the active-organisation header: it is the list you consult *to*
choose, and a stale choice must not stop you correcting it.
 * @summary Get My Organisations
 */
export const getMyOrganisations = (signal?: AbortSignal) => {
  return customInstance<MyOrganisationsOut>({
    url: `/my-organisation/memberships`,
    method: 'GET',
    signal,
  })
}

export const getGetMyOrganisationsQueryKey = () => {
  return [`/my-organisation/memberships`] as const
}

export const getGetMyOrganisationsQueryOptions = <
  TData = Awaited<ReturnType<typeof getMyOrganisations>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getMyOrganisations>>, TError, TData>
}) => {
  const { query: queryOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetMyOrganisationsQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyOrganisations>>> = ({ signal }) =>
    getMyOrganisations(signal)

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMyOrganisations>>,
    TError,
    TData
  > & { queryKey: QueryKey }
}

export type GetMyOrganisationsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMyOrganisations>>
>
export type GetMyOrganisationsQueryError = unknown

/**
 * @summary Get My Organisations
 */

export function useGetMyOrganisations<
  TData = Awaited<ReturnType<typeof getMyOrganisations>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getMyOrganisations>>, TError, TData>
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetMyOrganisationsQueryOptions(options)

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey }

  query.queryKey = queryOptions.queryKey

  return query
}
